var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { attrs: { id: "subscription-upgrade-existing-subscription-card" } },
    [
      _vm.apparatusesToUpdate &&
      _vm.apparatusesToUpdate.length &&
      _vm.subscriptionProduct
        ? _c(
            "b-card",
            {
              staticClass: "paid-subs-info-card mb-0 sub-card mx-1",
              attrs: {
                "body-class": "subs-info-card-body",
                "data-test-hook": "existing-subscription-modal-paid-card"
              },
              scopedSlots: _vm._u(
                [
                  {
                    key: "header",
                    fn: function() {
                      return [
                        _c(
                          "div",
                          {
                            staticClass: "plan-header",
                            attrs: {
                              "data-test-hook":
                                "subscription-upgrade-existing-subscription-card-header"
                            }
                          },
                          [
                            _vm._v(
                              " " + _vm._s(_vm.subscriptionProduct.name) + " "
                            )
                          ]
                        )
                      ]
                    },
                    proxy: true
                  }
                ],
                null,
                false,
                2082072047
              )
            },
            [
              _c(
                "div",
                { staticClass: "subscriptionCardText mt-3" },
                [
                  _c(
                    "b-row",
                    [
                      _c("b-col", [
                        _vm.subscriptionProduct &&
                        _vm.subscriptionProduct.description
                          ? _c(
                              "strong",
                              {
                                attrs: {
                                  "data-test-hook":
                                    "existing-subscription-modal-premium-monitoring-max-products-text"
                                }
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.subscriptionProduct.description
                                    ) +
                                    " "
                                )
                              ]
                            )
                          : _vm._e()
                      ])
                    ],
                    1
                  ),
                  _vm._l(_vm.apparatusesToUpdate, function(apparatus, index) {
                    return _c(
                      "b-row",
                      { key: index },
                      [
                        apparatus.type === 0 || apparatus.apparatusType === 0
                          ? _c("ExpandableHsbSubscriptionFeaturesList", {
                              attrs: {
                                id: `${apparatus.apparatusId}-${"current"}`,
                                "generator-name": apparatus.name,
                                "is-covered": true
                              }
                            })
                          : apparatus.type === 2 ||
                            apparatus.apparatusType === 2
                          ? _c("ExpandableTankSubscriptionFeaturesList", {
                              attrs: {
                                id: `${apparatus.apparatusId}-${"current"}`,
                                "tank-name": apparatus.name,
                                "is-covered": true
                              }
                            })
                          : _vm._e()
                      ],
                      1
                    )
                  })
                ],
                2
              )
            ]
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }